import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as D from '../../deps';
import BackstagePodcastEpisodeSubheaderLarge from '../common/BackstagePodcastSubheader/BackstagePodcastEpisodeSubheaderLarge';
import BackstagePodcastEpisodeSubheaderSmall from '../common/BackstagePodcastSubheader/BackstagePodcastEpisodeSubheaderSmall';

import BackstagePodcastPageBase from './BackstagePodcastPageBase';

const BackstagePodcastEpisodePageBase = props => {
  const { episodeId, isMobileDevice } = props;

  return (
    <BackstagePodcastPageBase
      pandoraId={episodeId}
      subheaderLarge={<BackstagePodcastEpisodeSubheaderLarge episodeId={episodeId} />}
      subheaderSmall={
        !isMobileDevice && <BackstagePodcastEpisodeSubheaderSmall episodeId={episodeId} />
      }
      mainContent={props.mainContent}
    />
  );
};

BackstagePodcastEpisodePageBase.propTypes = {
  mainContent: PropTypes.node.isRequired,
  episodeId: PropTypes.string.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
};

export function mapStateToProps(state) {
  return {
    isMobileDevice: D.Utils.Capabilities.isMobileDevice(state),
  };
}

export default connect(mapStateToProps)(BackstagePodcastEpisodePageBase);
